import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../data/models/user';



export interface UserState {
  user: User;
}

const initialState: UserState = {
  user: {} as User,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    removeUser: (state, action: PayloadAction<number>) => {
      state.user = {} as User;
    },
  },
});

export const { setUser, removeUser } = userSlice.actions;
export default userSlice.reducer;